

import { Col, List, message, Row, Upload, UploadProps } from "antd";
import {DeleteFilled,WarningFilled,DiffFilled,DownloadOutlined  } from '@ant-design/icons';
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { getAnSpecificMachineDocumentFile, getMachineDocumentFile, getpaymentgetwayFiles, InsertMachineDocumentFile, newPaymentgetwayRequest, newPaymentgetwayRequestUpload } from "../../api/api";
import { useAppSelector, useAppDispatch } from "../../redux/store/storehooks";
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from "../../services/toast.notification";
import { useNavigate, useParams } from 'react-router-dom';
import { json } from "stream/consumers";


const NewPaymentUploadParcik = () => {
    var filsUpload=new Array<any>();
    const {id} = useParams();
    const [data, setData] = useState<any[]>([]);
    const [documentList,setDocumentList] = useState<any>([]);
    const [labNameValid, setLabNameValid] = useState('')
    const columns: ColumnsType<any> = [
        { title: 'کد مرکز', dataIndex: 'prk_AndriodLab_AutoID', key: 'prk_AndriodLab_AutoID' },
        { title: 'نام', dataIndex: 'str_LabPersianName', key: 'str_LabPersianName' },
    ];
    const navigate = useNavigate();
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(true);

    const [inputValues, setInputValue] = useState({
        desc: ""
    });

    const [validation, setValidation] = useState({
        desc: ""


    });
    const loadPaymentFiles = () => {
    

        getpaymentgetwayFiles(Number(id))
        .then((result:any) => {
            console.log(result.data.data)
            setDocumentList(result.data.data)
        })
        .catch((error) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000)
        
        })

    }
    //handle submit updates
    function handleChange(event: any) {

        const { name, value } = event.target;
        if (event.target.type == "checkbox") {
            setInputValue({ ...inputValues, [name]: event.target.checked });
        }
        else
            setInputValue({ ...inputValues, [name]: value });

    }
    useEffect(() => {
        // let x=useParams()
        // setId(Number (useParams()))
        loadPaymentFiles()
    }, [])
  

 
    const uploadDocumentFile: UploadProps = {
        action: '',
        listType: 'text',
        beforeUpload(file) {
            let filePas=file.name.split('.')
            const doc = filePas[filePas.length-1];
            // const doc = file.type === 'xlsx/docx';
            if (doc!='xlsx' && doc!='docx') {
              message.error(`فقط فایل های با پسوند xlsx , docx  قابل قبول می باشد`);
              return
            }
          console.log(file);
          return new Promise(resolve => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = function () {
                console.log(reader.result)

                if (reader.result){

                    modelObject(
                        reader.result?.toString(),
                        file.name,
                        file.type
                    )

                }
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
                errorNotify("خطا در بارگذاری فایل",undefined,5000)
            };
          });
        },
    };
    
    const AddNewFile = () => {
        
        newPaymentgetwayRequestUpload(
             filsUpload
        )
        .then((result:any) => {
            sucessNotify("اطلاعات با موفقیت ذخیره شده",undefined,5000)
            loadPaymentFiles();
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }
    const modelObject=(base64File:string,fileName:string,fileExtension:string)=>{
        
        let model:any={}
    model.fileId =0
    model.requestId= Number(id)/// =>
    model.labId= myStore.auth.userId
    model.base64File= base64File
    model.fileName= fileName
    model.fileExtension= fileExtension
    model.isImportant=false
    model.isDisable= false
    let modelAray=[]
    modelAray.push(model)
    filsUpload.push(model)
    console.log('data is ', JSON.stringify(modelAray))
    // AddNewFile(modelAray)
    }


     const downloadDocumentPaymentFiles = (item:any) => {

        console.log(item);
        const downloadLink = document.createElement("a");       
        downloadLink.href = item.str_filesBase64;
        downloadLink.download = item.str_FileName;
        downloadLink.click();
        
     } 
    const inActiveFunctionPrompt = () => {

        errorNotify("این گزینه در حال حاضر غیر فعال می باشد")
 
     }
     const uploadFile = (item: any) => {
        AddNewFile()
    }
 
    return (

        <>

            <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
                                        <List
                        //                     header={
                        //                         <Row>
                        //                             <Col>
                        //                                 <Upload {...uploadDocumentFile}>
                        //                                     <DiffFilled  style={{ color: 'Green',fontSize: '18px' }}/>
                        //                                 </Upload>
                                                        
                        //                             </Col>
                        //                             <Col lg={23} md={23} sm={23} xs={23}>فایل  آپلود</Col>
                        //                             <Col style={{margin:'10px',textAlign:'right',width:'100%'}}>
                        //                             <button
                        //     onClick={(e) => uploadFile(e)}
                        //     style={{ 'background': 'green', 'color': 'white', padding: '7px', border: 'none', borderRadius: '7px' }}
                        // >آپلود همه</button>
                        //                             </Col>
                        //                         </Row>
                        //                     }
                                            style={{margin: '10px' }}
                                            footer={undefined}
                                            bordered
                                            dataSource={documentList}
                                            renderItem={(item:any) => (
                                                <List.Item actions={
                                                    [
                                                        <DeleteFilled  onClick={inActiveFunctionPrompt}  style={{ color: 'red',fontSize: '18px' }}/>,
                                                        <WarningFilled  onClick={inActiveFunctionPrompt}  style={{ color: 'orange',fontSize: '18px' }}/>,
                                                        <DownloadOutlined   onClick={()=>downloadDocumentPaymentFiles(item)}  style={{ color: 'blue',fontSize: '18px' }}/>
                                                    ]
                                                }>
                                                    <>
                                                        <List.Item.Meta
                                                            description={item.str_FileName}
                                                        />
                                                    </>
                                                </List.Item>
                                            )}
                                        />
                                    </Col>
         
            </Row>
        </>
    );
};

export default NewPaymentUploadParcik

